import stylizedWrap from './stylized-wrapper';
import styles from './styles.module.scss';

export const OverviewBanner = stylizedWrap('overview-banner', styles);
